// src/hooks/useEleve.js
import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useClasse = (classeID, enabled,reload) => {


  const urldelete = classeID ? `${url}classes/${classeID}/` : url+'classes/';
  return useApi(urldelete, [],reload, enabled);
};